import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = "919711884840";
export const WHATSAPP_NUMBER_2 = "919811337753";
export const CONTACT_EMAIL = "Styleindiadelhi@gmail.com";
export const INSTAGRAM_URL = "https://www.instagram.com/styleindiadelhi";
export const INSTAGRAM_HANDLE = "@styleindiadelhi";
export const YOUTUBE_URL = "https://www.youtube.com/@StyleIndiadelhi";
export const YOUTUBE_HANDLE = "@StyleIndiadelhi";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sid_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const buildWhatsAppLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const buildCatalogueUrl = () => `${API_BASE}/catalogue/download`;
